export const SIZE_HIGH_1 = 20 ;
export const SIZE_MUDIUM_1 = 16 ;
export const SIZE_MUDIUM_2 = 18 ;
export const SIZE_MUDIUM_3 = 15 ;
export const TABLE_TXT_SZ_CONTENT = 14 ;
export const TABLE_TXT_SZ_HEADER = 18 ;